import { render, staticRenderFns } from "./objectRepresentation.vue?vue&type=template&id=7423fdb7"
import script from "./objectRepresentation.vue?vue&type=script&lang=js"
export * from "./objectRepresentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports